export const WALLET_CONNECTION_INITIATED = 'wallet_connection_initiated'
export const WALLET_CONNECTION_SUCCESS = 'wallet_connection_success'
export const WALLET_CONNECTION_FAILED = 'wallet_connection_failed'
export const WALLET_DISCONNECT = "wallet_disconnect";

// Transaction Events
export const TRANSACTION_INITIATED = 'transaction_initiated'
export const TRANSACTION_SUCCESS = 'transaction_success'
export const TRANSACTION_FAILED = 'transaction_failed'
